import { ListData } from '@fi-app/components/items-list/list-data.service';
import { Injector } from '@angular/core';
import {
    ItemsListElementType,
    ItemsListHeader,
    ItemsListHeaderProperties,
} from '@fi-app/components/items-list/items-list-header';
import { ObjectTypes } from '@fi-shared/types';
import { IFormReportQuestionAnswer } from '@fi-app/fi-form/fi-form-report/fi-form-report';

export class FormReportQuestionCommonListData extends ListData<IFormReportQuestionAnswer> {
    constructor(injector: Injector, reportItemClickCallback: (item: IFormReportQuestionAnswer) => void) {
        super(injector, true);

        this.MultiSelect = false;
        this.ShowDelete = false;
        this.ShowCheckAll = false;
        this.ShowCheckBox = false;
        this.CanShowLoadMore = false;
        this.ListItemBigPadding = true;
        this.ObjectType = ObjectTypes.Form;

        this.Header.push(
            new ItemsListHeader(
                this.appTextService.get('form.answer'),
                'AnswerValue',
                new ItemsListHeaderProperties('CcmListItem-Name CcmListItem-NoBorder', true, ItemsListElementType.A, {
                    onClick: ($event, data: IFormReportQuestionAnswer) => {
                        $event.stopPropagation();
                        reportItemClickCallback(data);
                    },
                    RowItemClass: 'CcmRowFullWidth',
                }),
            ),
        );

        this.Header.push(
            new ItemsListHeader(
                this.appTextService.get('common.count'),
                'AnswerCount',
                new ItemsListHeaderProperties(
                    'CcmList-Column-Narrow CcmListItem-NoBorder',
                    true,
                    ItemsListElementType.A,
                    {
                        onClick: ($event, data: IFormReportQuestionAnswer) => {
                            $event.stopPropagation();
                            reportItemClickCallback(data);
                        },
                        isRightAligned: true,
                        smallRightPadding: true,
                        RowItemClass: 'CcmRowFullWidth',
                    },
                ),
            ),
        );

        this.Header.push(
            new ItemsListHeader(
                this.appTextService.get('statistic.show_percentage'),
                'AnswerPercentage',
                new ItemsListHeaderProperties(
                    'CcmList-Column-Narrow CcmListItem-NoBorder',
                    true,
                    ItemsListElementType.A,
                    {
                        onClick: ($event, data: IFormReportQuestionAnswer) => {
                            $event.stopPropagation();
                            reportItemClickCallback(data);
                        },
                        isRightAligned: true,
                        smallRightPadding: true,
                        RowItemClass: 'CcmRowFullWidth',
                    },
                ),
                undefined,
                undefined,
                (data) => `${data.AnswerPercentage} %`,
            ),
        );
    }
}
